import { render, staticRenderFns } from "./PasswordResetMailSentPane.vue?vue&type=template&id=12e5c033"
import script from "./PasswordResetMailSentPane.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailSentPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports